"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOADING_AUTO_LAYOUT_ITERATION_TIMEOUT_MS = exports.DUMMY_ITERATION = exports.DUMMY_ITERATION_HASH = void 0;
exports.DUMMY_ITERATION_HASH = `auto-layout-step-sha256-FIRST_ITERATION`;
exports.DUMMY_ITERATION = {
    hash: exports.DUMMY_ITERATION_HASH,
    order: 0,
    nodes: {},
    boardLocation: "",
    loaded: true,
    stats: {},
    computeUnits: 0,
    committed: false,
    generatedOn: 0,
};
exports.LOADING_AUTO_LAYOUT_ITERATION_TIMEOUT_MS = 2000;
//# sourceMappingURL=constants.js.map